import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
    retrieve,
    reset,
    showChords,
    hideChords
} from '../../actions/song/show';
import { del, loading, error } from '../../actions/song/delete';
import Display from './Display';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = theme => ({
    root: theme.mixins.gutters({
        paddingTop: 16,
        paddingBottom: 16,
        marginTop: theme.spacing.unit * 3,
        maxWidth: 1000,
        marginLeft: 'auto',
        marginRight: 'auto'
    }),
    rButton: {
        position: 'absolute',
        top: 5,
        right: 5
    }
});

class Show extends Component {
    static propTypes = {
        error: PropTypes.string,
        loading: PropTypes.bool.isRequired,
        retrieved: PropTypes.object,
        retrieve: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
        deleteError: PropTypes.string,
        deleteLoading: PropTypes.bool.isRequired,
        deleted: PropTypes.object,
        del: PropTypes.func.isRequired
    };

    componentDidMount() {
        this.props.retrieve(decodeURIComponent(this.props.match.params.id));
    }

    componentWillUnmount() {
        this.props.reset();
    }

    del = () => {
        if (window.confirm('Are you sure you want to delete this item?'))
            this.props.del(this.props.retrieved);
    };

    render() {
        if (this.props.deleted) return <Redirect to=".." />;

        const item = this.props.retrieved;
        const {
            showChords,
            setShowChords,
            setHideChords,
            classes
        } = this.props;

        return (
            <div>
                <Link to=".." className={classes.rButton}>
                    <Button variant="contained" color="primary" size="small">
                        Back to list
                    </Button>
                </Link>

                {item && (
                    <Display
                        showChords={showChords}
                        setShowChords={setShowChords}
                        setHideChords={setHideChords}
                        item={item}
                        includeNextSong={true}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        error: state.song.show.error,
        loading: state.song.show.loading,
        retrieved: state.song.show.retrieved,
        deleteError: state.song.del.error,
        deleteLoading: state.song.del.loading,
        deleted: state.song.del.deleted
    };
};

const mapDispatchToProps = dispatch => {
    return {
        retrieve: id => dispatch(retrieve(id)),
        del: item => dispatch(del(item)),
        reset: () => {
            dispatch(reset());
            dispatch(error(null));
            dispatch(loading(false));
        },
        setShowChords: () => {
            dispatch(showChords());
        },
        setHideChords: () => {
            dispatch(hideChords());
        }
    };
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Show)
);



// WEBPACK FOOTER //
// ./src/components/song/Show.js